import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Sort } from '@/shared/api/types';

export const sortSlice = createSlice({
  name: 'sorterSlice',
  initialState: {
    vaccinationRegistry: [{ key: 'birthDate', order: 'desc' }] as Sort[],
    vaccinationRegistryArchive: [{ key: 'birthDate', order: 'desc' }] as Sort[],
    pathologyActs: [{ key: 'performedAt', order: 'desc' }] as Sort[],
  },
  reducers: {
    setVaccinationRegistrySort(state, action: PayloadAction<Sort[] | undefined>) {
      state.vaccinationRegistry = action.payload ?? [];
    },
    setVaccinationRegistryArchiveSort(state, action: PayloadAction<Sort[] | undefined>) {
      state.vaccinationRegistryArchive = action.payload ?? [];
    },
    setPathologyActsSort(state, action: PayloadAction<Sort[] | undefined>) {
      state.pathologyActs = action.payload ?? [];
    },
  },
});

export const {
  setVaccinationRegistrySort,
  setVaccinationRegistryArchiveSort,
  setPathologyActsSort,
} = sortSlice.actions;
